import React, { useEffect, useState } from "react";
import "../../style.css";
import axios from "axios";
import Logo from "../LogoComponent";
import { Link, NavLink } from "react-router-dom";
import { FiUser, FiShield, FiUsers, FiBookOpen, FiLock, FiKey, FiMenu, FiX } from "react-icons/fi";
import fallbackAvatar from "../../assets/AddProfileImgs/A4.png";
import "../Profile/style.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from 'react-router-dom'
import { useNotification } from "../../Context/NotificationContext";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { clearSessionAndRedirect, getAuthToken, getStoredUserData, handleAuthError, handleAuthResponse, isTokenExpired } from "../../Helpers/authSession";

const config = require("../../Helpers/config.json");

const Account = () => {
  const [accountLoading, setAccountLoading] = useState(true);
  const [accountError, setAccountError] = useState(false);
  const [profilesError, setProfilesError] = useState(false);
  const [profilesLoading, setProfilesLoading] = useState(true);
  const [savedDetails, setSavedDetails] = useState({ name: '', number: '' });
  const [masterSetup, setMasterSetup] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const accountLocation = useLocation();
  const requestedSection = accountLocation.hash.slice(1);
  const section = ['account-details', 'account-security', 'account-family', 'account-preferences'].includes(requestedSection) ? requestedSection : 'account-details';
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [CategoryId, setCategoryId] = useState([]);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [data] = useState([]);
  const [allProfiles, setAllProfiles] = useState([]);
  const [isForget, setIsForgot] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableAdminPasswordShow, setEnableAdminPasswordShow] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [adminConfirmPassword, setAdminConfirmPassword] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [profileToDelete, setProfileToDelete] = useState(null);
  const { showNotification } = useNotification();

  const requireAuthToken = () => {
    const authToken = getAuthToken();

    if (!authToken || isTokenExpired(authToken)) {
      clearSessionAndRedirect();
      return "";
    }

    return authToken;
  };

  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  useEffect(() => {
    const authToken = getAuthToken();

    if (!authToken || isTokenExpired(authToken)) {
      clearSessionAndRedirect();
      return;
    }

    fetch(`${config["baseUrl2"]}v1/account`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        if (handleAuthResponse(res)) return null;
        return res.json();
      })
      .then((res) => {
        if (!res) return;
        if (res.data) {
          setSavedDetails({ name: res.data.name || '', number: res.data.phone_number || '' });
          setName(res.data.name || '');
          setNumber(res.data.phone_number || '');
          setEmail(res.data.email);
          if (res.data.is_user_code == 1) {
            setEnableAdminPasswordShow(true);
          } else {
            setEnableAdminPasswordShow(false);
          }
        } else { setAccountError(true); }
      })
      .catch(() => setAccountError(true))
      .finally(() => setAccountLoading(false));
  }, []);

  useEffect(() => {
    const internalNavigation = localStorage.getItem('accountNavigation');

    if (!internalNavigation) {
      navigate(-1); // Go back to the previous page
    }

  }, [navigate]);

  useEffect(() => {
    fetch(
      `${config["baseUrl2"]}profile/listProfiles?userId=${localStorage.getItem(
        "id"
      )}`,
      {
        method: "GET",
        headers: { "content-type": "application/json" },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success === true) {
          setAllProfiles(res?.profiles || []);
        } else { setProfilesError(true); }
      }).catch(() => setProfilesError(true)).finally(() => setProfilesLoading(false));

  }, []);

  const handleDeleteProfile = () => {
    if (!profileToDelete) return;

    setLoading(true);
    const authToken = requireAuthToken();
    if (!authToken) return;

    const uid = getStoredUserData()?.uid;

    fetch(`${config["baseUrl2"]}profile/removeProfile`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        uid: uid,
        profile_id: profileToDelete?.profile_id,
      }),
    })
      .then((res) => {
        if (handleAuthResponse(res)) return null;
        return res.json();
      })
      .then((res) => {
        if (!res) return;

        setLoading(false);
        if (res.success === true) {
          toast.success("Profile deleted successfully!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          const updatedProfiles = allProfiles.filter(
            (item) => item.profile_id !== profileToDelete.profile_id
          );
          setAllProfiles(updatedProfiles);
          setShowDeleteModal(false);
          setProfileToDelete(null);
        } else {
          showNotification({
            title: 'Delete Failed',
            message: res.message || "Failed to delete profile.",
            type: 'error'
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        showNotification({
          title: 'Error',
          message: "Something went wrong while deleting profile!",
          type: 'error'
        });
      });
  };

  const UpdateProfile = () => {
    setLoading(true);

    const data = {
      name: name,
      phoneNumber: number,
    };

    const authToken = requireAuthToken();
    if (!authToken) return;

    axios
      .patch(`${config["baseUrl2"]}v1/account`, data, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      })
      .then((res) => {
        setSavedDetails({ name, number });
        setLoading(false);
        localStorage.setItem("name", name);
        toast.success("Profile updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (handleAuthError(error)) return;

        console.log("error", error);
        showNotification({
          title: 'Update Failed',
          message: error?.response?.data?.error?.message || error?.response?.data?.message || "Failed to update profile",
          type: 'error'
        });
      });
  };

  const enableUserCodeFunction = (isEnable = false) => {
    setLoading(true);
    const authToken = requireAuthToken();
    if (!authToken) return;

    const payload = {
      enabled: isEnable,
    };

    axios
      .patch(`${config["baseUrl2"]}v1/account/pin/status`, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      })
      .then((res) => {
        localStorage.setItem("enableUserCode", isEnable);
        setEnableAdminPasswordShow(isEnable);
        setMasterSetup(false);
        setAdminPassword('');
        setAdminConfirmPassword('');
        setPassword('');
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (handleAuthError(error)) return;

        showNotification({
          title: 'Update Failed',
          message: "Failed to update Master Key status",
          type: 'error'
        });
      });
  };

  function handleEnablePassword() {
    setLoading(true);
    if (adminPassword !== adminConfirmPassword) {
      setLoading(false);
      showNotification({
        title: 'Validation Error',
        message: "Confirm password does not match!",
        type: 'error'
      });
      return;
    }

    const authToken = requireAuthToken();
    if (!authToken) return;

    const payload = {
      pin: adminPassword,
    };

    axios
      .post(`${config["baseUrl2"]}v1/account/pin`, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      })
      .then((res) => {
        setLoading(false);
        localStorage.setItem("userCode", adminPassword);
        toast.success("Master Key enabled successfully!");
        enableUserCodeFunction(true);
      })
      .catch((error) => {
        setLoading(false);
        if (handleAuthError(error)) return;

        console.log("error", error);
        showNotification({
          title: 'Error',
          message: error?.response?.data?.error?.message || "Something went wrong while enabling Master Key",
          type: 'error'
        });
      });
  }

  const reset = () => {
    if (!newPassword || !currentPassword) {
      showNotification({
        title: 'Validation Error',
        message: "Field is empty!",
        type: 'warning'
      });
      return;
    } else if (newPassword !== confirmPassword) {
      showNotification({
        title: 'Validation Error',
        message: "New and confirm passwords do not match",
        type: 'warning'
      });
      return;
    }

    setLoading(true);
    const authToken = requireAuthToken();
    if (!authToken) return;

    axios
      .patch(`${config["baseUrl2"]}v1/account/password`, {
        currentPassword: currentPassword,
        newPassword: newPassword,
      }, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 204 || res.status === 200) {
          toast.success("Password changed successfully");
          setIsForgot(false);
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          showNotification({
            title: 'Reset Failed',
            message: "Password change failed",
            type: 'error'
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        if (handleAuthError(error)) return;

        console.error("error", error);
        showNotification({
          title: 'Error',
          message: error?.response?.data?.error?.message || error?.response?.data?.message || "An error occurred during password reset",
          type: 'error'
        });
      });
  };

  const initials = (savedDetails.name || 'Parent').trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  const detailsChanged = name !== savedDetails.name || number !== savedDetails.number;
  const sections = [
    { id: 'account-details', label: 'Account details', icon: FiUser },
    { id: 'account-security', label: 'Security', icon: FiShield },
    { id: 'account-family', label: 'Family profiles', icon: FiUsers },
    { id: 'account-preferences', label: 'Reading preferences', icon: FiBookOpen }
  ];
  const profileImage = item => item.image ? `${config.baseUrl2Image}/resources/static/assets/uploads/profiles/${item.image.split('/').pop().split('.')[0]}.png` : fallbackAvatar;

  return <div className="reader-profile parent-account" aria-busy={loading}>
    <header className="reader-header">
      <Link to="/dashboard" aria-label="FictionGenie stories"><Logo color="white" width="66px" /></Link>
      <button className="reader-menu-toggle" aria-label={menuOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={menuOpen} aria-controls="account-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? <FiX /> : <FiMenu />}</button>
      <nav id="account-navigation" className={menuOpen ? 'reader-navigation is-open' : 'reader-navigation'} aria-label="Main navigation"><NavLink to="/dashboard">Stories</NavLink><NavLink to="/account">Account</NavLink><NavLink to="/select-profile">Switch profile</NavLink></nav>
    </header>
    <main className="account-main">
      <div className="account-intro"><h1>Account settings</h1><p>Manage your details, security, and family profiles.</p></div>
      <div className="account-layout">
        <aside className="account-sidebar">
          <div className="account-owner"><span className="account-initials" aria-hidden="true">{initials}</span><div><strong>{savedDetails.name || 'Your account'}</strong><span>Parent account</span></div></div>
          <nav aria-label="Account sections">{sections.map(({ id, label, icon: Icon }) => <Link key={id} to={`#${id}`} className={section === id ? 'is-active' : ''} aria-current={section === id ? 'location' : undefined}><Icon aria-hidden="true" />{label}</Link>)}</nav>
        </aside>
        <div className="account-sections">
          <section className="parent-settings-card" id="account-details" hidden={section !== 'account-details'} aria-labelledby="account-details-title">
            <h2 id="account-details-title">Account details</h2><p>Keep your contact information up to date.</p>
            {accountLoading ? <p role="status">Loading account details…</p> : accountError ? <p className="account-message" role="alert">We couldn’t load your account details. Please refresh to try again.</p> : <form onSubmit={event => { event.preventDefault(); UpdateProfile(); }}>
              <fieldset className="account-fields" disabled={loading}>
                <div><label htmlFor="account-name">Full name</label><input id="account-name" value={name} onChange={event => setName(event.target.value)} required autoComplete="name" maxLength={100} /></div>
                <div><label htmlFor="account-phone">Phone number <span>(optional)</span></label><input id="account-phone" type="tel" value={number} onChange={event => setNumber(event.target.value)} placeholder="Add phone number" autoComplete="tel" /></div>
                <div className="account-field-full"><label htmlFor="account-email">Email address</label><input id="account-email" type="email" value={email || ''} disabled aria-describedby="account-email-help" /><small id="account-email-help">Your email address cannot be changed here.</small></div>
              </fieldset>
              <div className="account-actions"><button className="reader-button reader-button-yellow" type="submit" disabled={!detailsChanged || loading}>{loading ? 'Saving…' : 'Save changes'}</button></div>
            </form>}
          </section>
          <section className="parent-settings-card" id="account-security" hidden={section !== 'account-security'} aria-labelledby="account-security-title">
            <h2 id="account-security-title">Security</h2>
            <div className="account-setting-row"><span className="account-setting-icon"><FiLock /></span><div className="account-setting-copy"><h3>Password</h3><p>Update your sign-in password.</p></div><button className="reader-button reader-button-outline" disabled={loading || accountLoading || accountError} aria-expanded={isForget} aria-controls="account-password-form" onClick={() => setIsForgot(!isForget)}>{isForget ? 'Close' : 'Change password'}</button></div>
            {isForget && <form id="account-password-form" className="account-expanded-form" onSubmit={event => { event.preventDefault(); reset(); }}><fieldset className="account-fields" disabled={loading}>
              <div className="account-field-full"><label htmlFor="account-current-password">Current password</label><input id="account-current-password" type="password" value={currentPassword} onChange={event => setCurrentPassword(event.target.value)} autoComplete="current-password" required /></div>
              <div><label htmlFor="account-new-password">New password</label><input id="account-new-password" type="password" value={newPassword} onChange={event => setNewPassword(event.target.value)} minLength={6} required autoComplete="new-password" /><small>At least 6 characters.</small></div>
              <div><label htmlFor="account-confirm-password">Confirm new password</label><input id="account-confirm-password" type="password" value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} minLength={6} required autoComplete="new-password" /></div>
            </fieldset><div className="account-actions"><button className="reader-button reader-button-quiet" type="button" onClick={() => { setIsForgot(false); setCurrentPassword(''); setNewPassword(''); setConfirmPassword(''); }}>Cancel</button><button className="reader-button reader-button-yellow" disabled={loading}>Update password</button></div></form>}
            <div className="account-setting-row account-master-row"><span className="account-setting-icon"><FiKey /></span><div className="account-setting-copy"><h3>Master Key</h3><p>Require a separate key to access parent settings.</p></div><div className="account-toggle-wrap"><button className="account-toggle" role="switch" aria-label="Master Key" aria-checked={enableAdminPasswordShow} disabled={loading || accountLoading || accountError} onClick={() => enableAdminPasswordShow ? setShowConfirmationModal(true) : setMasterSetup(!masterSetup)}><span /></button><span>{enableAdminPasswordShow ? 'On' : 'Off'}</span></div></div>
            {enableAdminPasswordShow && !masterSetup && <button className="account-edit-key" disabled={loading} onClick={() => setMasterSetup(true)}>Change Master Key</button>}
            {masterSetup && <form className="account-expanded-form" onSubmit={event => { event.preventDefault(); handleEnablePassword(); }}><p>{enableAdminPasswordShow ? 'Choose a new Master Key.' : 'Set up a Master Key to protect parent settings.'}</p><fieldset className="account-fields" disabled={loading}>
              <div className="account-field-full"><label htmlFor="account-key-password">Account login password</label><input id="account-key-password" type="password" value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" required /></div>
              <div><label htmlFor="account-master-key">Master Key</label><input id="account-master-key" type="password" value={adminPassword} onChange={event => setAdminPassword(event.target.value)} autoComplete="new-password" required /></div>
              <div><label htmlFor="account-confirm-key">Confirm Master Key</label><input id="account-confirm-key" type="password" value={adminConfirmPassword} onChange={event => setAdminConfirmPassword(event.target.value)} autoComplete="new-password" required /></div>
            </fieldset><div className="account-actions"><button type="button" className="reader-button reader-button-quiet" onClick={() => { setMasterSetup(false); setPassword(''); setAdminPassword(''); setAdminConfirmPassword(''); }}>Cancel</button><button className="reader-button reader-button-yellow" disabled={loading}>Save Master Key</button></div></form>}
          </section>
          <section className="parent-settings-card" id="account-family" hidden={section !== 'account-family'} aria-labelledby="account-family-title"><h2 id="account-family-title">Family profiles</h2><p>Manage each child’s profile and reading details.</p>
            {profilesLoading ? <p role="status">Loading family profiles…</p> : profilesError ? <p role="alert" className="account-message">We couldn’t load family profiles. Please refresh to try again.</p> : allProfiles.length ? <ul className="account-family-grid">{allProfiles.map(item => <li key={item.profile_id} className="account-child-card"><img src={profileImage(item)} alt={`${item.name}'s avatar`} /><h3>{item.name}</h3><Link className="reader-button reader-button-outline" to="/profile" state={{ profile: item, isVerified: true }}>Edit profile</Link><button className="account-remove" disabled={loading} onClick={() => { setProfileToDelete(item); setShowDeleteModal(true); }} aria-label={`Remove ${item.name}'s profile`}>Remove</button></li>)}</ul> : <div className="account-empty"><FiUsers /><div><strong>No family profiles yet.</strong><p>Your child profiles will appear here.</p></div></div>}
          </section>
          <section className="parent-settings-card" id="account-preferences" hidden={section !== 'account-preferences'} aria-labelledby="account-preferences-title"><h2 id="account-preferences-title">Reading preferences</h2><p>Preferred genres help personalize story suggestions.</p>
            {data.length ? <div className="account-genres">{data.map(genre => <button key={genre.id} aria-pressed={CategoryId.includes(genre.id)} onClick={() => { const next = CategoryId.includes(genre.id) ? CategoryId.filter(id => id !== genre.id) : [...CategoryId, genre.id]; setCategoryId(next); }}>{genre.name}</button>)}</div> : <div className="account-empty"><FiBookOpen /><div><strong>No genres available yet.</strong><p>Available genres will appear here.</p></div></div>}
          </section>
        </div>
      </div>
    </main>
    <Modal show={showConfirmationModal} onHide={handleCloseConfirmationModal} centered className="reader-dialog" aria-labelledby="account-key-dialog-title"><Modal.Header closeButton><Modal.Title id="account-key-dialog-title">Turn off Master Key?</Modal.Title></Modal.Header><Modal.Body>Your separate Master Key will no longer be required to access parent settings.</Modal.Body><Modal.Footer><button className="reader-button reader-button-quiet" onClick={handleCloseConfirmationModal}>Cancel</button><button className="reader-button reader-button-yellow" disabled={loading} onClick={() => { enableUserCodeFunction(false); setShowConfirmationModal(false); }}>Turn off Master Key</button></Modal.Footer></Modal>
    <Modal show={showDeleteModal} onHide={() => !loading && setShowDeleteModal(false)} centered className="reader-dialog" aria-labelledby="account-delete-dialog-title"><Modal.Header closeButton={!loading}><Modal.Title id="account-delete-dialog-title">Remove profile?</Modal.Title></Modal.Header><Modal.Body>Are you sure you want to delete <strong>{profileToDelete?.name}</strong>’s profile? This action cannot be undone.</Modal.Body><Modal.Footer><button className="reader-button reader-button-quiet" disabled={loading} onClick={() => setShowDeleteModal(false)}>Cancel</button><button className="reader-button account-delete-button" disabled={loading} onClick={handleDeleteProfile}>{loading ? 'Removing…' : 'Delete profile'}</button></Modal.Footer></Modal>
  </div>;
};

export default Account;
